import DatabaseReference from '../platform/DatabaseReference';
import DeviceModel from '../../models/scoopm/Device';

export default class Device extends DatabaseReference {
  get Model() {
    return DeviceModel;
  }
}
